import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import * as actions from "../../../../../app/actions/generalActions";
import { useObjectsUIContext } from "../../../../../_metronic/layout/components/basePage/pages/ObjectsUIContext";
import { useFilterObjectsUIContext } from "../../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";


const selectedObjects = (entities, ids) => {
  const _objects = [];
  ids.forEach((id) => {
    const object = entities.find((el) => el.id === id);
    if (object) {
      _objects.push(object);
    }
  });
  return _objects;
};

export function UserChangePassDialog({ api, show, onHide, currentState, softDelete, getQueryFunctionName }) {
  const objectsUIContext = useObjectsUIContext();
  const filterUIContext = useFilterObjectsUIContext();

  const objectsUIProps = useMemo(() => {
    return {
      ids: objectsUIContext.ids,
      setIds: objectsUIContext.setIds,
      queryParams: filterUIContext.queryParams,
    };
  }, [objectsUIContext, filterUIContext]);

  const dispatch = useDispatch();

  const { objects, isLoading, name, lastError, lastMsg } = useSelector(
    (state) => ({
      objects: selectedObjects(currentState.entities, objectsUIProps.ids),
      isLoading: currentState.actionsLoading,
      name: currentState.name
    }),
    shallowEqual
  );

  useEffect(() => { }, [isLoading, dispatch]);

  useEffect(() => {
    if (!objectsUIProps.ids || objectsUIProps.ids.length === 0) {
      onHide();
    }

  }, [objectsUIProps.ids]);

  const resetPasswords = () => {
    dispatch(actions.updateObjects(api, name, objectsUIProps.ids, objects[0], "UserResetPassword")).then(() => {
      dispatch(actions.fetchObjects(api, name, objectsUIProps.queryParams, getQueryFunctionName)).then(() => {
        objectsUIProps.setIds([]);
        onHide();
      });
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          بازیابی رمز عبور
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>آیا از بازیابی رمز عبور افراد انتخاب شده اطمینان دارید ؟</span>
        )}
        {isLoading && <span>در حال  بازیابی رمز عبور ...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            انصراف
          </button>
          <> </>
          <button
            type="button"
            onClick={resetPasswords}
            className="btn btn-primary btn-elevate"
          >
            تایید
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}


